module.exports = __webpack_public_path__ + "img/pd-img-body4.49472c6b.png";